<template>
    <div
      id="ranges"
      class="row"
    >
    <div class="col-12">
        <vuetify-table
            :type="type"
            :headers="headers"
            :api-u-r-l="apiURL"
            :title="title"
            :query-params="queryParams"
            :is-numeration="isNumeration"
        >
            <template v-slot:actions-filters>
                <v-tooltip bottom>
                    <span>Realizar busqueda </span>
                </v-tooltip>
                <v-col cols="3" class="v-col">
                    <v-btn
                        :color="themeColor"
                        dark
                        block
                        @click="dialogInvoices = true"
                    >
                        <v-icon>mdi-file-search-outline</v-icon>Buscar Factura
                    </v-btn>
                </v-col>
            </template>
            <template v-slot:actions="{ item }">

              <v-tooltip bottom >
                <template v-slot:activator="{ on }">
                  <v-icon
                    :color="themeColor"
                    dark
                    @click="openModalDelete(item)"
                    v-on="on"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
        </vuetify-table>
      </div>
      <SearchInvoice
        v-if="dialogInvoices"
        :dialog="dialogInvoices"
        :counterid="counterId"
        @chageShowDialogInvoice="changeDialogInvoice"
        @saveShowDialogInvoice="saveDialogInvoice"
      ></SearchInvoice>
    </div>
  </template>

  <script>
  import { mapGetters } from 'vuex';
  import VuetifyTable from '~/components/VuetifyTable';
  import SearchInvoice from '~/components/SearchInvoice';

  export default {
    middleware: 'auth',
    components: {
      VuetifyTable,
      SearchInvoice,
    },
    props: {
      enterpriseId: { default: '' },
      counterId: { default: '' },
      id: { default: '' },
    },
    data: () => ({
      currentTitle: '',
      queryParams: [],
      type: '',
      dialogDelete: false,
      dialog: false,
      dialogInvoices: false,
      toggleStatus: false,
      toggleStatusDelete: false,
      headers: [
        {
          text: 'Numero de control',
          value: 'control_number',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Numero documento',
          value: 'document_number',
          align: 'left',
          sortable: true,
        },
        {
          text: 'receiver_name',
          value: 'receiver_name',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Serie',
          value: 'serie',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Fecha emision',
          value: 'issue_date',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
      name: '',
      isNumeration: true,
    }),
    computed: {
      apiURL() {
        return `/api/enterprises/${this.enterpriseId}/invocesget/${this.counterId}`;
      },
      title() {
        return 'Facturas';
      },
      ...mapGetters({
        themeColor: 'theme/themeColor',
      }),
    },
    methods: {
        changeDialogInvoice(val) {
            this.dialogInvoices = val;
            // this.mifuncion();
        },
        async saveDialogInvoice() {
          this.queryParams = await this.fetchData();
        },
        async mounted() {
        this.queryParams = await this.fetchData();
        },
        async fetchData() {
        // Simula una llamada a API para obtener datos actualizados
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve([/* datos actualizados */]);
          }, 1000);
        });
        },
        openModalDelete(item) {
            this.dialogDelete = true;
            this.item = item;
            const url = `${this.apiURL}/${this.item.id}`;
            window.axios.delete(url)
            .then((response) => {
              this.toggleStatusDelete = false;
                this.$store.dispatch('notifications/show', {
                message: response.data.message,
                type: response.data.type,
                });
                this.queryParams = this.fetchData();
            });
        },
        mifuncion() {
          this.queryParams = `/api/enterprises/${this.enterpriseId}/invocesget/${this.counterId}`;
        },
    },
  };
  </script>
